import $ from "jquery";
import { mapMutations } from "vuex";
export const PrefillWithInitialsMixin = {
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      setFamilySituation: "forms/SET_FAMILY_SITUATION"
    }),
    fillFormWithInitials(arr) {
      if (arr) {
        arr.forEach(element => {

          if(!element.value) {
            return;
          }

          if (
            element.name == "consumption[family_situation]" &&
            !!element.value
          ) {
            this.setFamilySituation(parseInt(element.value));
            return;
          }
          let a = $(`[name = "${element.name}"]`);
          switch (a.attr("type")) {
            case "text":
              {
                a.val(element.value);
                a.trigger("change");
              }
              break;
            case "radio":
              {
                let val = element.value;
                $(
                  `input[type=radio][name = "${element.name}"][value = "${val}"]`
                ).attr("checked", "checked");
              }
              break;
            case undefined:
              {
                if ($(`[name = "${element.name}"]`).is("select")) {
                  $(`[name = "${element.name}"]`).val(element.value);
                }
              }
              break;
            default:
              break;
          }
        });
      }
    }
  }
};
